import React from 'react'

class ArrowLeft extends React.Component {
  render() {
    return (
      <svg className="arrowLeft" width="30" height="30" viewBox="0 0 30 30">
        <path fill="#fff" fillRule="nonzero" d="M11.128 15l8.486 8.485-1.415 1.414-9.899-9.9L18.2 5.1l1.414 1.414z" />
      </svg>
    )
  }
}

export default ArrowLeft
